import { styled } from 'styled-components';

import { cssBreakpoints } from 'theme/theme';

export const ViewJobPageRecommendationsHolder = styled.div`
  @media all and (min-width: ${cssBreakpoints.mdUp}) {
    display: none;
  }
`;
